import { P as PropTypes } from './useSlotProps-263f7ba4.js';

const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

export { refType$1 as r };
//# sourceMappingURL=refType-6972e729.js.map
